interface IVesselAttractionCategories {
  dining: string;
  bars: string;
  activities: string;
  entertainment: string;
  kidsAndTeens: string;
  spaAndFitness: string;
}

export const VesselAttractionCategories: IVesselAttractionCategories = {
  dining: "dining",
  bars: "bars",
  activities: "activities",
  entertainment: "entertainment",
  kidsAndTeens: "kids_and_teens",
  spaAndFitness: "spa_and_fitness",
};

export const vesselAttractionPreferredOrder = [
  VesselAttractionCategories.dining,
  VesselAttractionCategories.entertainment,
  VesselAttractionCategories.activities,
  VesselAttractionCategories.spaAndFitness,
  VesselAttractionCategories.bars,
  VesselAttractionCategories.kidsAndTeens,
];
